import React from 'react';
import { css } from '@emotion/core';
import colors from "../../Styles/colors";

let styles = css`
    color: ${colors.highlight};
    text-transform: uppercase;
    font-weight: bold;
`;

export default function New() {
  return <span css={styles}>NEW{'\u00a0'}</span>
}